var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_456)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M68.3897 13.5681L69.0547 16.1781C69.9267 19.5981 70.3627 21.3081 71.4377 22.6361C72.5127 23.9631 74.0947 24.7461 77.2597 26.3101L79.6737 27.5041L77.0647 28.1681C73.6437 29.0411 71.9337 29.4771 70.6057 30.5521C69.2787 31.6271 68.4967 33.2091 66.9317 36.3741L65.7387 38.7881L65.0737 36.1791C64.2007 32.7581 63.7647 31.0471 62.6897 29.7201C61.6147 28.3931 60.0327 27.6111 56.8677 26.0461L54.4547 24.8531L57.0627 24.1871C60.4847 23.3151 62.1947 22.8791 63.5217 21.8041C64.8497 20.7291 65.6317 19.1471 67.1967 15.9821L68.3897 13.5681ZM51.1437 73.6801L50.7647 77.2821C50.4077 80.6791 50.2287 82.3781 49.0637 83.3221C47.8967 84.2661 46.1987 84.0881 42.8017 83.7311C39.4057 83.3741 37.7067 83.1951 36.7627 82.0291C35.8187 80.8631 35.9967 79.1641 36.3537 75.7681L36.7327 72.1651L51.1437 73.6801Z",
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5128 41.9699C73.5358 51.2619 68.2088 57.9339 60.7548 61.9099C59.0178 62.8359 58.1498 63.2989 57.6838 63.8799C57.2188 64.4609 56.9958 65.2659 56.5508 66.8729L56.2048 68.1239C55.4238 70.9489 55.0338 72.3609 53.9358 73.1089C52.8378 73.8569 51.3798 73.7039 48.4648 73.3979L39.0558 72.4089C36.1408 72.1019 34.6838 71.9489 33.7648 70.9889C32.8478 70.0289 32.7588 68.5669 32.5818 65.6399L32.5028 64.3459C32.4028 62.6859 32.3518 61.8559 32.0218 61.1939C31.6908 60.5319 30.9368 59.8919 29.4288 58.6099C23.0368 53.1789 19.4948 45.5779 20.4708 36.2899C22.0648 21.1269 35.4538 10.1059 50.3778 11.6749C52.1928 11.8639 53.9838 12.2389 55.7238 12.7919",
    stroke: "#2F2F30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_302_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3897 13.5681L69.0547 16.1781C69.9267 19.5981 70.3627 21.3081 71.4377 22.6361C72.5127 23.9631 74.0947 24.7461 77.2597 26.3101L79.6737 27.5041L77.0647 28.1681C73.6437 29.0411 71.9337 29.4771 70.6057 30.5521C69.2787 31.6271 68.4967 33.2091 66.9317 36.3741L65.7387 38.7881L65.0737 36.1791C64.2007 32.7581 63.7647 31.0471 62.6897 29.7201C61.6147 28.3931 60.0327 27.6111 56.8677 26.0461L54.4547 24.8531L57.0627 24.1871C60.4847 23.3151 62.1947 22.8791 63.5217 21.8041C64.8497 20.7291 65.6317 19.1471 67.1967 15.9821L68.3897 13.5681ZM51.1437 73.6801L50.7647 77.2821C50.4077 80.6791 50.2287 82.3781 49.0637 83.3221C47.8967 84.2661 46.1987 84.0881 42.8017 83.7311C39.4057 83.3741 37.7067 83.1951 36.7627 82.0291C35.8187 80.8631 35.9967 79.1641 36.3537 75.7681L36.7327 72.1651",
    fill: "#FF8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1437 73.6801L50.7647 77.2821C50.4077 80.6791 50.2287 82.3781 49.0637 83.3221C47.8967 84.2661 46.1987 84.0881 42.8017 83.7311C39.4057 83.3741 37.7067 83.1951 36.7627 82.0291C35.8187 80.8631 35.9967 79.1641 36.3537 75.7681L36.7327 72.1651M68.3897 13.5681L69.0547 16.1781C69.9267 19.5981 70.3627 21.3081 71.4377 22.6361C72.5127 23.9631 74.0947 24.7461 77.2597 26.3101L79.6737 27.5041L77.0647 28.1681C73.6437 29.0411 71.9337 29.4771 70.6057 30.5521C69.2787 31.6271 68.4967 33.2091 66.9317 36.3741L65.7387 38.7881L65.0737 36.1791C64.2007 32.7581 63.7647 31.0471 62.6897 29.7201C61.6147 28.3931 60.0327 27.6111 56.8677 26.0461L54.4547 24.8531L57.0627 24.1871C60.4847 23.3151 62.1947 22.8791 63.5217 21.8041C64.8497 20.7291 65.6317 19.1471 67.1967 15.9821L68.3897 13.5681Z",
    stroke: "#2F2F30",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_302_456",
    x: 25.0664,
    y: 6.56812,
    width: 65.6074,
    height: 92.4502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.54902 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_302_456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_302_456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/Container.f8ccc9c2202919cfbcf9727e1cbad38c.svg";
export { ForwardRef as ReactComponent };